<div class="row center-card">
  <div class="left" (click)="goToAboutMe()" *ngIf="currentTab === 2">
    <span *ngIf="publicCardData.popup">{{ "booking" | translate }}</span>
    <span *ngIf="!publicCardData.popup">{{ "about_me" | translate }}</span>
    <i class="fas fa-chevron-left"></i>
  </div>

  <div class="right" (click)="goToService()" *ngIf="currentTab === 2">
    <span *ngIf="publicCardData.popup">{{ "menu" | translate }}</span>
    <span *ngIf="!publicCardData.popup">{{ "services" | translate }}</span>
    <i class="fas fa-chevron-right"></i>
  </div>

  <div [ngClass]=" (usuario.empresa === null && usuario.tarjetaPortada.esHorizontal) || (usuario.empresa !== null &&
        usuario.empresa.configuracionEmpresa !== null && usuario.empresa.configuracionEmpresa.esHorizontal) ? 'col-12' : 'col-6'"
    class="box-container"
  >
    <div class="box-center" [ngClass]="(usuario.empresa === null && usuario.tarjetaPortada.esHorizontal) ||
        (usuario.empresa !== null && usuario.empresa.configuracionEmpresa !== null &&
          usuario.empresa.configuracionEmpresa.esHorizontal) ? 'isHorizontal': ''"
    >
      <img [src]="logoImage" *ngIf="!logoImage"/>
      <h1>{{ publicCardData.nombre }}</h1>
      <hr />
      <span>{{ publicCardData.profesion }}</span>
      <hr
        [ngClass]="publicCardData.profesion !== '' ? 'mt-1' : ''"
        *ngIf="
          publicCardData.profesion !== '' ||
          (usuario.empresa !== null &&
            usuario.empresa.configuracionEmpresa !== null)
        "
      />
      <span *ngIf="usuario.empresa === null">{{ publicCardData.empresa }}</span>
      <span *ngIf="usuario.empresa !== null">{{ usuario.empresa.descripcion}}</span>
    </div>
  </div>
  <div [ngClass]="(usuario.empresa === null && usuario.tarjetaPortada.esHorizontal) || (usuario.empresa !== null &&
        usuario.empresa.configuracionEmpresa !== null &&
        usuario.empresa.configuracionEmpresa.esHorizontal) ? 'col-12' : 'col-6'">
    <div class="box-img">
      <img [src]="coverImage" *ngIf=" this.publicCardData.urlBanner !== '' || this.publicCardData.urlBanner !== null"/>
      <img src="assets\img\imagge.jpg" *ngIf=" this.publicCardData.urlBanner === '' && this.usuario.empresa.configuracionEmpresa.urlBanner === ''" class="img-fluid"/>
    </div>
  </div>
</div>

<!-- <div class="skeleton row" *ngIf="this.usuario.idUsuario === 0">
  <div class="box-container col-6">
    <div class="box-center">
      <div class="skeleton-img"></div>
      <hr />
      <div class="skeleton-text"></div>
      <hr />
      <div class="skeleton-text"></div>
    </div>
  </div>
  <div class="col-6">
    <div class="box-img">
      <div class="skeleton-banner"></div>
    </div>
  </div>
</div> -->
